
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, bool_type, list_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__startLoading, SetId, FormState__setValidationResponse_5219762A, FormState_get_empty, FormState_$reflection, CustomerConfiguration_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowSections, HookFlowProcedureModal, HookFlow_update, HookFlow_completedProcedureIds, HookFlow_initReturn, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../Widgets/Procedure/Hooks.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { DataTransfer_UnassignSetDto, DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { max, tryPick, sumBy, filter, singleton, append, choose, ofArray, empty, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch, Cmd_map } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unassignCmd } from "../../Requests/Set.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../../Widgets/Helper.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { isComplete, SetReturnCompletenessCheck, isRequired } from "./CompletenessCheck.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignResponse", "OnUnassign", "SetComment", "FetchError", "HookMsg", "SetSelectedSenderFiles", "SenderImageUploaded", "SetToolConfirmed"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.SelfServiceReturnSetDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", class_type("System.Exception")]], [["Item", HookFlowMsg_$reflection()]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]], [["Item1", string_type], ["Item2", bool_type]]]);
}

class State extends Record {
    constructor(Set$, CustomerConfiguration, Comment$, SuccessCallback, OnClose, FormState, SenderImageFiles, ImageUploading, Hooks, ConfirmedToolIds) {
        super();
        this.Set = Set$;
        this.CustomerConfiguration = CustomerConfiguration;
        this.Comment = Comment$;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
        this.Hooks = Hooks;
        this.ConfirmedToolIds = ConfirmedToolIds;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.SelfServiceReturnSetDialog.State", [], State, () => [["Set", DataTransfer_DetailSet_$reflection()], ["CustomerConfiguration", CustomerConfiguration_$reflection()], ["Comment", string_type], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type], ["Hooks", HookFlowState_$reflection()], ["ConfirmedToolIds", list_type(string_type)]]);
}

const maxSenderImages = 5;

function init(set$, customerConfiguration, successCallback, onClose) {
    const patternInput = HookFlow_initReturn(new ProcedureEntityReferenceDto(3, [set$.Id]), map((label) => parse(label.Id), set$.AssignedLabel));
    return [new State(set$, customerConfiguration, "", successCallback, onClose, FormState_get_empty(), empty(), false, patternInput[0], empty()), Cmd_map((Item) => (new Msg(4, [Item])), patternInput[1])];
}

function update(msg, state) {
    let file_1;
    switch (msg.tag) {
        case 0: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 1: {
            const dto = new DataTransfer_UnassignSetDto(state.Comment, choose((f) => {
                if (f.tag === 1) {
                    return f.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, state.SenderImageFiles), HookFlow_completedProcedureIds(state.Hooks), state.ConfirmedToolIds, undefined);
            const setId = new SetId(parse(state.Set.Id));
            return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), unassignCmd(setId, dto, (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(3, [Item_3])))];
        }
        case 2:
            return [new State(state.Set, state.CustomerConfiguration, msg.fields[0], state.SuccessCallback, state.OnClose, state.FormState, state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
        case 7: {
            const toolId = msg.fields[0];
            return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, state.SenderImageFiles, state.ImageUploading, state.Hooks, msg.fields[1] ? List_distinct(append(state.ConfirmedToolIds, singleton(toolId)), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }) : filter((id) => (id !== toolId), state.ConfirmedToolIds)), Cmd_none()];
        }
        case 3:
            return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.SenderImageFiles, false, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
        case 5: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y_1) => ((x_1 + y_1) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, newFiles, true, state.Hooks, state.ConfirmedToolIds), Cmd_uploadImage((Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(3, [Item_5])), formData)];
                }
                default:
                    return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, newFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
            }
        }
        case 6: {
            const response_1 = msg.fields[0];
            switch (response_1.tag) {
                case 0:
                    return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                    })) | 0;
                    return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_1.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
                }
            }
        }
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.Set, state.CustomerConfiguration, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, state.SenderImageFiles, state.ImageUploading, patternInput[0], state.ConfirmedToolIds), Cmd_map((Item) => (new Msg(4, [Item])), patternInput[1])];
        }
    }
}

export function SelfServiceReturnSetDialog(props) {
    let elems_2, Title, elems_1, Label_2;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.Set, props.CustomerConfiguration, props.SuccessCallback, props.OnClose);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton((elems_2 = [createElement(HookFlowProcedureModal, {
        Dispatch: (arg) => {
            dispatch(new Msg(4, [arg]));
        },
        State: state_2.Hooks,
    }), createElement(Dialog, (Title = t("general.self_service_return_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems_1 = toList(delay(() => append_1(singleton_1(reactElement("p", {
            children: t("general.self_service_return_description"),
        })), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.comment"),
            OnChange: (value_3) => {
                dispatch(new Msg(2, [value_3]));
            },
            TestId: "self-service-return-set-dialog-comment-test-id",
            Value: state_2.Comment,
        })), delay(() => {
            let elems;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("assignment_notification.sender_images"),
            }), createElement(ImageUpload, {
                ComponentState: state_2.ImageUploading ? "disabled" : componentState,
                SelectedFiles: state_2.SenderImageFiles,
                SetSelectedFile: (files) => {
                    dispatch(new Msg(5, [files]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(isRequired(state_2.CustomerConfiguration) ? singleton_1(createElement(SetReturnCompletenessCheck, {
                Configuration: state_2.CustomerConfiguration,
                ConfirmedToolIds: state_2.ConfirmedToolIds,
                FormState: state_2.FormState,
                OnToolConfirmed: (tupledArg_1) => {
                    dispatch(new Msg(7, [tupledArg_1[0], tupledArg_1[1]]));
                },
                Set: state_2.Set,
            })) : empty_1(), delay(() => append_1(singleton_1(createElement(HookFlowSections, {
                Dispatch: (arg_1) => {
                    dispatch(new Msg(4, [arg_1]));
                },
                FormState: state_2.FormState,
                ReceiverTitleKey: "procedure.hooks.receiver_procedures_return",
                SenderTitleKey: "procedure.hooks.sender_procedures_return",
                State: state_2.Hooks,
                TestIdPrefix: "self-service-return-set",
            })), delay(() => {
                const matchValue = FormState__getValidation(state_2.FormState, t, "global");
                if (matchValue == null) {
                    return empty_1();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue,
                    }));
                }
            }))))));
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-self-service-return-set-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_2 = t("general.save"), {
            ComponentState: ((state_2.ImageUploading ? true : HookFlow_hasMandatoryUncompletedHooks(state_2.Hooks)) ? true : !isComplete(state_2.CustomerConfiguration, state_2.Set, state_2.ConfirmedToolIds)) ? "disabled" : componentState,
            Label: Label_2,
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-self-service-return-set-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

